import moment from 'moment';

let now = new Date();
let startt = moment(new Date(moment(new Date()).subtract(1, 'hour')));

let ends = moment(new Date());

export const setStartDateTime = (data) => ({
  type: 'SET_START_DATE_TIME',
  payload: data
});

export const setTopologyStartDateTime = (data) => ({
  type: 'SET_TOPOLOGY_START_DATE_TIME',
  payload: data
});

export const setMonitoringStartDateTime = (data) => {
  console.log('startmonired',data);
  
  return ({
  type: 'SET_MONITORING_START_DATE_TIME',
  payload: data
})};

export const resetMonitoringLegend = (data) => {
  return ({
  type: 'RESET_MONITORING_LEGEND',
  payload: data
})};

export const setTopologyReloadTime = (data) => ({
  type: 'SET_TOPOLOGY_RELOAD_TIME',
  payload: data
});

export const setMonitoringReloadTime = (data) => ({
  type: 'SET_MONITORING_RELOAD_TIME',
  payload: data
});

export const setEndDateTime = (data) => ({
  type: 'SET_END_DATE_TIME',
  payload: data
});

export const toggleTopoplogySidePanel = (data) => ({
  type: 'CLEAR_TOPOLOGY_SIDE_PANEL',
  payload: data
})

export const setTopologyEndDateTime = (data) => ({
  type: 'SET_TOPOLOGY_END_DATE_TIME',
  payload: data
});

export const setMonitoringEndDateTime = (data) => ({
  type: 'SET_MONITORING_END_DATE_TIME',
  payload: data
});

export const setLast1Hour = () => ({
  type: 'SET_LAST_1_HOUR'
});

export const setLast6Hours = () => ({
  type: 'SET_LAST_6_HOURS'
});

export const setCustomTime = () => ({
  type: 'SET_CUSTOM_TIME'
});

export const closeSubnetwork = (data) => ({
  type: 'CLEAR_SUBNETWORK',
  payload: data
})

const TIME_RANGE_INITIAL_STATE = {
  start: startt,
  end: ends,
  topologyStart: startt,
  monitoringStart: startt,
  topologyend: ends,
  monitoringend: ends,
  last1Hour: true,
  last6Hours: false,
  topologyReloadTime: undefined,
  monitoringReloadTime: undefined,
  topologySidePanelFlag: true,
  closeSubnetworkFlag:true,
  monitoringLegendReset: false
};

export default function dateTimeReducer(state = TIME_RANGE_INITIAL_STATE, action) {
  console.log('action',action?.payload);
  
  switch (action.type) {
    case 'SET_START_DATE_TIME':
      return { ...state, start: action.payload };

    case 'SET_TOPOLOGY_START_DATE_TIME':
      return { ...state, topologyStart: action.payload };

    case 'SET_MONITORING_START_DATE_TIME':
      return { ...state, monitoringStart: action.payload };

    case 'RESET_MONITORING_LEGEND':
      return { ...state, monitoringLegendReset: action.payload}

    case 'SET_TOPOLOGY_RELOAD_TIME':
      return { ...state, topologyReloadTime: action.payload }
      
    case 'SET_MONITORING_RELOAD_TIME':
      return { ...state, monitoringReloadTime: action.payload }
      
    case 'SET_END_DATE_TIME':
      return { ...state, end: action.payload };

    case 'SET_TOPOLOGY_END_DATE_TIME':
      return { ...state, topologyend: action.payload };

    case 'CLEAR_TOPOLOGY_SIDE_PANEL':
      return { ...state, topologySidePanelFlag: action.payload };

    case 'SET_MONITORING_END_DATE_TIME':
      return { ...state, monitoringend: action.payload };


    case 'SET_LAST_1_HOUR':
      return {
        ...state,
        last1Hour: true,
        last6Hours: false
      };

    case 'SET_LAST_6_HOURS':
      return {
        ...state,
        last1Hour: false,
        last6Hours: true
      };

    case 'SET_CUSTOM_TIME':
      return {
        ...state,
        last1Hour: false,
        last6Hours: false
      };
    case 'CLEAR_SUBNETWORK':
      return { ...state, closeSubnetworkFlag: action.payload };
    default:
      return state;
  }
}
